<template>
    <div class="o-tiles-scrollable tiles-scrollable">
        <RecycleScroller
            ref="scroller"
            :items="items"
            key-field="id"
            v-slot="{ item }"
            :item-size="tileHeight"
            :buffer="virtualScrollerBuffer"
            class="tiles-scrollable-scroller"
        >
            <MTilesRow
                :items="item.items"
                :view="view"
                :tile-type="tileType"
                @onClick="handleClickTile"                
            />
        </RecycleScroller>
        <AScrollButton
            v-if="isScrollButton"
            :view="view"
        />
    </div>
</template>

<script>
import { mapGetters}  from "vuex";

import MTilesRow from '../../molecules/m-tiles-row';
import AScrollButton from '../../atoms/a-scroll-button';

import { TERMINAL_VIDEOSHOP } from "@/utils/constants/pages";
import { EVENTS } from "@/utils/constants/bus-events-constants";

export default {
    name: "OTilesScrollable",
    components: {
        MTilesRow,
        AScrollButton
    },
    props: {
        view: {
            type: String,
            default: ''
        },
        items: {
            type: Array,
            required: true
        },
        isScrollButton: {
            type: Boolean,
            default: false
        },
        tileType: {
            type: String,
            required: true
        },
        tileHeight: {
            type: Number,
            required: true
        }
    },
    computed: {
        ...mapGetters([
            'getObject',
            'getMapConfigProp'
        ]),
        isScroll() {
            const el = this.$refs.scroller;
            return el.offsetHeight < el.scrollHeight;
        },
        cinemaServiceId() {
            return Number(this.getMapConfigProp('constants.CINEMA_SERVICE_ID')) || 0;
        },
        commonConfigParams() {
            return this.getMapConfigProp('components.OTilesScrollable.params') || {};
        },
        virtualScrollerBuffer() {
            return this.commonConfigParams.buffer || 500;
        }
    },
    methods: {
        handleClickTile(item) {
            const isCinemaService = item.id === this.cinemaServiceId;
            const isTransport = item.meta.is_transport;
            
            if (item.type === 'tenant') {
                this.$bus.$emit(EVENTS.MODALS.INIT_TILES_MODAL, item.id, this.view);
            } else if (isCinemaService) {
                this.$router.push({ name: TERMINAL_VIDEOSHOP });
            } else if (isTransport) {
                this.$router.push({
                    name: 'terminal.transport',
                    params: {
                        serviceId: item.id
                    }
                })
            } else {
                const params = { itemId: item.id };
                this.$bus.$emit(EVENTS.MODALS.INIT_SERVICES_MODAL, params, this.view);
            }

            this.$emit('tileClick', item);
        }
    }
}
</script>

<style lang="scss" src="./theme.scss" />
